import { render } from "./Recuts.vue?vue&type=template&id=40478a18"
import script from "./Recuts.vue?vue&type=script&lang=js"
export * from "./Recuts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__